/**
* PdfEvent.js
* 
* Created on Dec 8, 2017
*
* @author Olivier van der Pool for &ranj
**/
export default class PdfEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

PdfEvent.GENERATE_REPORT_PROGRESS = "GENERATE_REPORT_PROGRESS";
PdfEvent.GENERATE_REPORT_COMPLETE = "GENERATE_REPORT_COMPLETE";
PdfEvent.DOWNLOAD_REPORT = "DOWNLOAD_REPORT";